import { IInventoryListVM } from "../../models/response/IInventoryManagementResponse";

export const InventoryInitialState: IInventoryListVM = {
  Inventory: [],
};
